import React from 'react';

const Reference = (props) => {
  return (
    <li className="reference__list__item">
      <i></i>
      <span dangerouslySetInnerHTML={{ __html: props.ReferenceItem }}></span>
    </li>
  );
};

export default Reference;
